module.exports = __webpack_public_path__ + "assets/img/login-forgot.13c6a670.jpg";